import React from 'react';
import Icon from '../AppIcon';
import { MONTHLY_GOAL } from '../../services/fundingService';

const monthLabel = (month) => {
  if (!month || !/^\d{4}-\d{2}$/.test(month)) return 'this month';
  const [year, mon] = month.split('-').map(Number);
  const date = new Date(Date.UTC(year, mon - 1, 1));
  return date.toLocaleString('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' });
};

const ServerCostMeter = ({ goal = MONTHLY_GOAL, raised = 0, loading = false, month }) => {
  const safeGoal = Number(goal) || MONTHLY_GOAL;
  const safeRaised = Number(raised) || 0;
  const progress = safeGoal > 0 ? Math.min(safeRaised / safeGoal, 1) : 0;
  const label = monthLabel(month);

  return (
    <div className="bg-slate-800 rounded-xl p-3 mb-5 text-white">
      <div className="flex items-center justify-between text-xs mb-2">
        <span className="flex items-center gap-1.5 text-gray-300">
          <Icon name="Server" size={12} className="text-cyan-400" />
          Monthly Server Costs
        </span>
        <span className="font-bold text-cyan-400">~${safeGoal.toFixed(2)}/mo</span>
      </div>
      <div className="bg-white/10 rounded-full h-1.5">
        <div
          className="bg-gradient-to-r from-emerald-400 to-cyan-400 h-1.5 rounded-full transition-all duration-500"
          style={{ width: loading ? '0%' : `${progress * 100}%` }}
        />
      </div>
      <div className="flex justify-between text-[9px] text-gray-500 mt-1">
        <span>
          Raised {label}: {loading ? '…' : `$${safeRaised.toFixed(2)}`}
        </span>
        <span>${safeGoal.toFixed(2)} goal</span>
      </div>
    </div>
  );
};

export default ServerCostMeter;
